export default "__VITE_ASSET__B8MmYBG1__"